// src/components/Header.jsx
import React from 'react';

function Header() {
    return (
        <header className="h-16 flex items-center justify-between text-white shadow-md px-4 header_bg">
            <div className="logo-left">
                <img 
                    src="/assets/logo-autoshow.png" 
                    alt="Left Logo" 
                    className="p-1 h-16 w-auto" // <-- UPDATED
                />
            </div>
            
            <div className="logo-right">
                <img src="/assets/logo-marii.png" alt="Right Logo" className="h-10 w-auto" />
            </div>
        </header>
    );
}

export default Header;